interface UserType {
  role?: string
}

const userTypeLabelKey = ({ role }: UserType): string => {
  if (role !== 'user') return 'usersManagement:role_admin'
  return 'usersManagement:role_user'
}

export default userTypeLabelKey
